import { render, staticRenderFns } from "./PrAffiliates.vue?vue&type=template&id=a19d591c&scoped=true&"
import script from "./PrAffiliates.ts?vue&type=script&lang=ts&"
export * from "./PrAffiliates.ts?vue&type=script&lang=ts&"
import style0 from "./PrAffiliates.scss?vue&type=style&index=0&id=a19d591c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19d591c",
  null
  
)

export default component.exports